import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus6() {
  return (
    <BusDetailsCard
      busId="bus6"
      title="Bus 6 - Route Details"
      busName="Bus 6"
      vehicleNo="TN74F6234"
      backTo="/?buses=1"
    />
  );
}